import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { useTranslation, Trans } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Footer, Header, Navbar } from "../components";
import ErrorPage from "./ErrorPage";
import customAxios from "../utils/customAxios";

import { styles } from "../styles";

const LowonganKerjaPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const { data, isLoading, isError } = useQuery({
    queryKey: ["jobFairs"],

    queryFn: async () => {
      const response = await customAxios.get("job-fairs");

      return response?.data?.data || null;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  if (isError) {
    return (
      <ErrorPage
        code="500"
        titleKey="error.500_title"
        defaultTitle="Gagal Memuat Data"
        subtitleKey="error.500_subtitle"
        defaultSubtitle="Terjadi masalah saat terhubung ke server kami. Silakan coba lagi nanti atau kembali ke"
      />
    );
  }

  const renderContent = () => {
    if (isLoading)
      return (
        <div className="w-full space-y-8 animate-pulse">
          <div className="w-full p-20 bg-gray-200 rounded"></div>
          <div className="w-full p-20 bg-gray-200 rounded"></div>
          <div className="w-full p-20 bg-gray-200 rounded"></div>
        </div>
      );
      
    if (!data) return null;

    return (
      <>
        {data.map((info, index) => (
          <div
            className="flex smd:flex-col w-full max-h-full gap-8 px-6 py-6 bg-[#EFEFEF] rounded-[8px] items-center justify-start"
            key={index}
          >
            <div className="flex relative w-[120px] overflow-hidden rounded-md group shrink-0">
              <img
                src={info.image}
                alt={currentLanguage === "en" ? info.title_en : info.title_id}
                className="object-cover w-full h-full"
              />
            </div>
            <div className="flex flex-col gap-2">
              <h1 className={`${styles.headingM} font-bold smd:text-center`}>
                {currentLanguage === "en" ? info.title_en : info.title_id}
              </h1>
              <p className={`${styles.textLMediumM} smd:text-center`}>
                {currentLanguage === "en"
                  ? info.short_description_en
                  : info.short_description_id}
              </p>
              <Link to={info.slug} className="flex items-center gap-4 px-4 py-2 mt-6 transition-all border rounded border-primary-50 text-primary-50 w-fit hover:text-white hover:bg-primary-50 smd:self-center">
                <p>Detail</p>
                <FaChevronRight />
              </Link>
            </div>
          </div>
        ))}
      </>
    );
  };

  return (
    <>
      <Navbar />
      <Header title={t("job.header")} />

      <main
        className={`${styles.paddingX} flex flex-col items-center smd:flex-col gap-12 py-20`}
      >
        <div className="min-w-[600px] smd:min-w-full flex flex-col px-6 py-12 gap-4 h-full bg-[#EFEFEF] rounded-[8px]">
          <p className="font-bold">
            <Trans i18nKey="job.warning">WASPADA PENIPUAN!</Trans>
          </p>
          <p>
            <Trans i18nKey="job.desc">
              Dalam proses perekrutan calon karyawan,{" "}
              <b className="text-primary-40">UNIVERAL</b> tidak pernah meminta
              biaya apa pun, baik secara langsung maupun melalui pihak ketiga.
              Setiap calon karyawan yang menerima penawaran kerja dari{" "}
              <b className="text-primary-40">UNIVERAL</b> akan menjalani proses
              perekrutan resmi yang dilakukan oleh proyek atau pihak yang
              membutuhkan. Kami ingin mengingatkan para pencari kerja agar
              selalu berhati-hati dalam proses perekrutan ini dan teliti data
              serta informasi yang diberikan dalam proses tersebut.
            </Trans>
          </p>
        </div>

        <div className="flex flex-col items-center gap-6 min-w-[600px] smd:min-w-full w-full">
          {renderContent()}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default LowonganKerjaPage;
